export default __webpack_public_path__ + "static/media/BEL.15819c5c.svg";